import { openAtom } from "@mongez/react-atom";

export const searchDrawerAtom = openAtom("searchDrawer");

export const linksDrawerAtom = openAtom("linksDrawer");

export const isIOSAtom = openAtom("isIOS", false);

export * from "./cookiePreferencesPortal";